var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFreddoEsp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 288 288",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{stroke:#000;stroke-miterlimit:10;}.cls-2,.cls-3{stroke:#765638;stroke-width:5px;}.cls-2,.cls-3,.cls-4{stroke-linecap:round;stroke-linejoin:round;}.cls-2{fill:url(#linear-gradient);}.cls-3{fill:#efceb4;}.cls-4,.cls-5{fill:none;}.cls-4{stroke:#fff;stroke-width:6px;}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 138.83,
    y1: 225.98,
    x2: 138.83,
    y2: 107,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#6d4422"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#825833"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#b68c60"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#c69c6d"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M134.18,215.39l-4.94-.78L156.05,44.85a1.25,1.25,0,0,1,1.43-1l2.46.38a1.25,1.25,0,0,1,1,1.44Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "179.66 161 98.66 161 89.66 107 106.05 225.98 171.61 225.98 188 107 179.66 161"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "179.66 161 188 107 89.66 107 98.66 161 179.66 161"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-4",
    points: "116 116 99.61 116 107.81 182.92"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    width: 288,
    height: 288
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFreddoEsp);
export default __webpack_public_path__ + "static/media/freddo-esp.a0972278a6b23dc7580de672a92f2567.svg";
export { ForwardRef as ReactComponent };